<!-- 核收或核退 -->
<template>
  <div v-loading="loading">
    <el-form
      :rules="rules"
      :model="submitData"
      label-width="120px"
      ref="submitData"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="Amount > 0 ? '核收总额' : '核付总额'">
              <el-input
                type="number"
                v-model="CollectionAmount"
                disabled
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
         <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="Amount > 0 ? '剩余可收' : '剩余可付'">
              <el-input
                type="number"
                v-model="UnPaid"
                disabled
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item label="结算方式" prop="PayType">
              <el-select
                v-model="submitData.PayType"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in payWayList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="Amount > 0 ? '实收金额' : '实付金额'">
              <el-input
                type="number"
                v-model="submitData.NowPay"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
         <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="Amount > 0 ? '已收总额' : '已付总额'">
              <el-input
                type="number"
                v-model="Paid"
                disabled
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
         <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-form-item :label="Amount > 0 ? '收款日期' : '付款日期'">
              <el-date-picker
                v-model="submitData.PayTime"
                align="right"
                type="date"
                placeholder="选择日期"
                style="width:100%"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="备注">
              <el-input v-model="submitData.Remark"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="btn-ctn">
      <el-button size="small" class="search-btn" @click="cancel()"
        >取消</el-button
      >
      <el-button
        size="small"
        class="search-btn btn-primary"
        @click="submitForm()"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["RecordId", "Amount", "Type","Paid"],
  components: {},
  data() {
    return {
      loading: false,
      payWayList: [],
      CollectionAmount:0,
      UnPaid:0,
      submitData: {
        RecordId: this.RecordId,
        PayType: "",
        Remark: "",
        NowPay:0,
        PayTime:""
      },
      rules: {
        PayType: [{ required: true, message: "该项必填", trigger: "blur" }],
      },
    };
  },
   created: function() {
    var aData = new Date();
    this.submitData.PayTime =
      aData.getFullYear() + "-" + (aData.getMonth() + 1) + "-" + aData.getDate();
  },
  mounted() {
    this.getPay();
    if (this.Amount == 0) {
      this.$util.warningMsg("结款金额必须不能等于0");
    } else this.CollectionAmount = Math.abs(this.Amount);

    this.UnPaid = (Math.abs(this.Amount) - this.Paid).toFixed(2);
  },
  methods: {
    cancel() {
      this.$emit("closeSettleUp");
    },
    submitForm() {
      if (this.CollectionAmount == 0) {
        this.$util.warningMsg("结款金额必须不能等于0");
        return;
      }
      this.$refs["submitData"].validate((valid) => {
        if (valid) {
            this.$confirm(
              "您确认要提交此核结款吗？一旦提交则该结余款将会被结清！",
              "提示",
              {
                confirmButtonText: "确定提交",
                cancelButtonText: "取消",
                type: "warning",
                center: false,
              }
            ).then(() => {
                this.loading = true;
                this.$util
                  .axiosPost({
                    url: "/api/RevenueManagement/SettleUpRecords",
                    data: this.submitData,
                    hideLoading: true,
                  })
                  .then((res) => {
                    this.$util.successMsg("结款成功");
                    this.$emit("closeSettleUp",true);
                  })
                  .finally(() => {
                    this.loading = false;
                  });
              })
              .catch(() => {});
        } else {
          return false;
        }
      });      

    },
    //  结算方式
    getPay() {
      this.$util.getPay(1).then((data) => {
        this.payWayList = data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-content {
  margin: 5px;
}
.btn-ctn {
  text-align: right;
}
.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
